module.exports = __webpack_public_path__ + "img/Poorter_hotel-128.f641342b.jpg";